import { render, staticRenderFns } from "./UserUserTokenList.vue?vue&type=template&id=706e67bc&scoped=true&"
import script from "./UserUserTokenList.vue?vue&type=script&lang=ts&"
export * from "./UserUserTokenList.vue?vue&type=script&lang=ts&"
import style0 from "./UserUserTokenList.vue?vue&type=style&index=0&id=706e67bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706e67bc",
  null
  
)

export default component.exports